import { defineExample } from './util'

export const invCircleEx1 = defineExample({
  metadata: { author: 'unknown' },
  renderSettings: {
    exposure: 0.78,
    skipIters: 19,
    drawMode: 'light',
    colorInitMode: 'colorInitPosition',
    backgroundColor: [0, 0, 0],
    camera: {
      zoom: 0.3920263077123037,
      position: [0.3045698404312134, -0.16651256382465363],
    },
  },
  transforms: {
    d2523f69_dd2d_49cb_b14f_d9448e0bfb31: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.20895783603191376, y: -0.01184399425983429 },
      variations: {
        bc571c35_0b03_4865_a765_d00cd71031a6: {
          type: 'invCircleVar',
          weight: 1,
          params: { radius: 1, a: 0, b: 0, restricted: 0 },
        },
      },
    },
    f881eb22_51d8_4076_859c_2a06d35d0da6: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: 0.031095966696739197, y: 0.04129904508590698 },
      variations: {
        '025ea6fd_a2fa_4d4e_9a35_7dce33da0a53': {
          type: 'rectanglesVar',
          weight: 1,
          params: { x: 1, y: 1 },
        },
      },
    },
  },
})

export const invCircleEx2 = defineExample({
  metadata: { author: 'unknown' },
  renderSettings: {
    exposure: 0.859,
    skipIters: 21,
    drawMode: 'light',
    colorInitMode: 'colorInitPosition',
    backgroundColor: [0, 0, 0],
    camera: {
      zoom: 0.9251791818743573,
      position: [0.09001222252845764, -0.021536290645599365],
    },
  },
  transforms: {
    d2523f69_dd2d_49cb_b14f_d9448e0bfb31: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.23288826644420624, y: -0.005004972219467163 },
      variations: {
        bc571c35_0b03_4865_a765_d00cd71031a6: {
          type: 'invCircleVar',
          weight: 1,
          params: {
            radius: 0.5,
            a: -0.5,
            b: 0,
            restricted: 1,
          },
        },
      },
    },
    '65355ec1_be15_4802_a57e_bf8127dcc79b': {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.10455072671175003, y: -0.041391462087631226 },
      variations: {
        d206ee66_3217_4da9_8c3a_c6953a96f67a: {
          type: 'invCircleVar',
          weight: 1,
          params: { radius: 1, a: -1, b: -1, restricted: 1 },
        },
      },
    },
    '1f4a3cbd_644a_423a_a8b6_8078b743c758': {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.2272648960351944, y: -0.007128598168492317 },
      variations: {
        ad3a5e09_a04f_41d1_a82f_df6b1bc30bf1: {
          type: 'invCircleVar',
          weight: 1,
          params: { radius: 1, a: -1, b: 1, restricted: 1 },
        },
      },
    },
    fc1d7c4e_13e0_430c_b0e1_eb065269b5d1: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.27756553888320923, y: 0.1139836385846138 },
      variations: {
        faf02b1e_5b58_43b1_8b57_41b1aab6275d: {
          type: 'invCircleVar',
          weight: 1,
          params: { radius: 1, a: 1, b: -1, restricted: 1 },
        },
      },
    },
    bd4eaa35_bc6c_432b_a3e7_591c44606fb3: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.07896293699741364, y: 0.040307074785232544 },
      variations: {
        '40d782b6_3e17_4267_896f_4824267d7058': {
          type: 'invCircleVar',
          weight: 1,
          params: { radius: 1, a: 1, b: 1, restricted: 1 },
        },
      },
    },
    eec7a7dc_90a6_4f45_8ddc_a9b3d05a5897: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.17469070851802826, y: 0.12231368571519852 },
      variations: {
        ef78fa70_9a69_40dd_a3af_53883e5fc9c9: {
          type: 'invCircleVar',
          weight: 1,
          params: { radius: 0.5, a: 0.5, b: 0, restricted: 1 },
        },
      },
    },
    '3db52413_ad76_44a2_9f4c_64300f64d765': {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.19901539385318756, y: -0.088944211602211 },
      variations: {
        '8edf1772_f43d_4101_b4c5_68a2d57377b8': {
          type: 'invCircleVar',
          weight: 1,
          params: {
            radius: 0.5,
            a: 0,
            b: -0.5,
            restricted: 1,
          },
        },
      },
    },
    fc8c50c7_3a69_499e_a403_6e010485c5da: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.04207536578178406, y: 0.1791514754295349 },
      variations: {
        '0c305855_ea7d_4638_b5c2_bba5898b7bc5': {
          type: 'invCircleVar',
          weight: 1,
          params: { radius: 0.5, a: 0, b: 0.5, restricted: 1 },
        },
      },
    },
  },
})
